export default {
  systemTemplate: 'System Templates',
  myTemplate: 'My Templates',
  customCreate: 'Custom Create',
  newTemplate: 'New Template',
  emptyMyTemplate: 'No templates yet',
  syncLang: 'Sync Config',
  syncLangTitle: 'Sync Config to Other Languages',
  syncLangDesc:
    'Sync current language ({lang}) template config to selected languages. Target language configs will be overwritten.',
  syncLangSuccess: 'Sync config successfully',
};
